import i18n from '@/i18n/i18n'
import { CropService } from '@/services/admin/CropService'
import { build_query, errorMessage } from '@/utilities/helpers.js'

import { CROP_ERROR_MESSAGES } from '@/constants/errorMessages'

const { t } = i18n.global

export const namespaced = true

export const allowedFilters = ['name', 'group']

export const state = {
  crops: null,
  crop: {},
  meta: null
}

export const mutations = {
  SET_CROPS(state, crops) {
    state.crops = crops.data
    state.meta = crops.meta
  },
  SET_CROP(state, crop) {
    state.crop = crop
  },
  ADD_CROP(state, crop) {
    state.crops.push(crop)
  },
  DELETE_CROP(state, cropId) {
    state.crops = state.crops.filter(crop => {
      return crop.id !== cropId
    })
  }
}

export const actions = {
  getCrops({ commit, dispatch }, query) {
    let newQuery = build_query(query, allowedFilters)
    return new Promise((resolve, reject) => {
      CropService.getCrops(newQuery)
        .then(response => {
          commit('SET_CROPS', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: CROP_ERROR_MESSAGES.getCropsError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getApplicableCrops({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      CropService.getApplicableCrops(params.regionId, params.cityId)
        .then(response => {
          commit('SET_CROPS', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.crop.crop')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getCrop({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      CropService.getCrop(params.cropId)
        .then(response => {
          commit('SET_CROP', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.crop.product')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createCrop({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      CropService.createCrop(params)
        .then(response => {
          commit('ADD_CROP', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.adding_problem', {
                element: t('store.admin.crop.crop')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  updateCrop({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      CropService.updateCrop(params.cropId, params.crop)
        .then(response => {
          commit('SET_CROP', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.update_error', {
                element: t('store.admin.crop.crop')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deleteCrop({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      CropService.deleteCrop(params.cropId)
        .then(response => {
          commit('DELETE_CROP', params.cropId)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.delete_error', {
                element: t('store.admin.crop.crop')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
